"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M13.453 2c4.545 0 7.64 2.57 8.647 6.916.45.046.814.266 1.13.62.27.312.451.694.527 1.104.056.249.084.47.084.691 0 .205-.025.402-.078.59l-.07.201H24l-.125 2.594-.481-.027a2.348 2.348 0 0 1-1.134-.383c-.37 1.703-1.252 3.048-2.657 4l-.004 3.19-.036.504h-5.748l-.037-.529-.002-1.493-.323.005a40.35 40.35 0 0 1-1.744-.035l-.002 1.564-.017.488H5.904l-.02-.548v-2.708c-1.147-.59-1.99-1.424-2.54-2.535H2.045C.92 16.21 0 15.241 0 14.054V11.1c0-1.187.92-2.156 2.046-2.156h.974c.15-.525.34-1.029.565-1.509l.551-3.63c.19-1.246 1.281-1.792 2.319-1.162l1.09.663C9.188 2.445 11.178 2 13.453 2Zm0 1.012c-2.236 0-4.155.453-5.696 1.317l-.235.131-1.547-.94c-.455-.277-.807-.1-.89.446L4.52 7.672l-.045.148a9.084 9.084 0 0 0-.627 1.757l-.093.379h-1.71C1.45 9.956.96 10.472.96 11.1v2.954c0 .628.49 1.143 1.086 1.143h1.907l.128.297c.482 1.12 1.287 1.916 2.475 2.463l.287.133v2.898h3.906v-2.107l.508.03c.531.033 1.1.051 1.72.057h.75a.395.395 0 0 0 .062-.005l.122-.024c.076-.013.154-.022.308-.034l.518-.043v2.126h3.905v-3.255l.237-.146c1.517-.941 2.354-2.353 2.568-4.259l.116-1.036.7.738c.114.12.233.226.355.316.119.087.235.157.352.21l.028-.598-.076-.053a2.004 2.004 0 0 1-.262-.227l-.362-.367.363-.365a.702.702 0 0 0 .153-.23c.046-.114.067-.24.067-.384a2.21 2.21 0 0 0-.062-.479 1.329 1.329 0 0 0-.294-.63c-.178-.2-.354-.299-.58-.303a.507.507 0 0 0-.118.017l-.478.115-.1-.506c-.807-4.137-3.563-6.534-7.796-6.534ZM6 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm7.138-4c1.424 0 2.71.234 3.862.68l-.526 1.27c-.966-.374-2.079-.585-3.355-.585-1.322 0-2.544.226-3.653.635L9 5.721A11.919 11.919 0 0 1 13.138 5Z",
    clipRule: "evenodd"
  })]
});